<template>
  <div class="modal fade" id="loginModal" tabindex="-1" aria-labelledby="loginModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <button type="button" class="close position-absolute" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="row no-gutters">
          <!-- 左侧品牌区域 -->
          <div class="col-md-6 brand-section">
            <div class="brand-content">
              <img src="../assets/images/logo_da.png" alt="Logo" class="brand-logo">
              <div class="welcome-text-container">
                <h2>Welcome Back!</h2>
                <p class="welcome-text">Nice to see you again, please login to your account.</p>
              </div>
              <div class="login-hint">
                Don't have an account? 
                <a href="#" @click.prevent="openSignUpModal">Sign up Now</a>
              </div>
            </div>
          </div>
          
          <!-- 右侧表单区域 -->
          <div class="col-md-6 form-section">
            <div class="form-content px-5 py-4">
              <h5 class="text-center mb-4">Log in</h5>
              <form @submit.prevent="handleSubmit">
                <div class="form-group">
                  <label>USERNAME OR PHONE NUMBER</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    v-model="formData.account"
                    placeholder="Username or Phone Number"
                    :class="{'is-invalid': loginError}"
                  >
                  <div class="invalid-feedback">{{ loginError }}</div>
                </div>

                <div class="form-group">
                  <label>PASSWORD</label>
                  <input 
                    type="password" 
                    class="form-control" 
                    v-model="formData.password"
                    placeholder="Password"
                    :class="{'is-invalid': loginError}"
                  >
                  <div class="invalid-feedback">{{ loginError }}</div>
                </div>

                <div class="d-flex justify-content-between align-items-center mb-4">
                  <div class="form-check">
                    <input 
                      type="checkbox" 
                      class="form-check-input" 
                      id="keepLoggedIn" 
                      v-model="formData.keepLoggedIn"
                    >
                    <label class="form-check-label" for="keepLoggedIn">
                      Keep me logged in
                    </label>
                  </div>
                  <a href="#" class="forgot-password" @click.prevent="handleForgotPassword">
                    Forgot your password?
                  </a>
                </div>

                <button 
                  type="submit" 
                  class="btn btn-dark btn-block py-2"
                  :disabled="!isFormValid"
                >
                  Log in now
                </button>

                <div class="text-center mt-4">
                  <button type="button" class="btn btn-success btn-block">
                    <i class="fab fa-weixin mr-2"></i>Log in with WeChat
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginModal',
  data() {
    return {
      formData: {
        account: '',
        password: '',
        keepLoggedIn: false
      },
      loginError: ''
    }
  },
  computed: {
    isFormValid() {
      return this.formData.account && 
             this.formData.password && 
             !this.loginError
    }
  },
  mounted() {
    // 监听打开登录模态框的事件
    this.$root.$on('open-login', () => {
      $('#loginModal').modal('show')
    })
  },
  beforeDestroy() {
    // 移除事件监听
    this.$root.$off('open-login')
  },
  methods: {
    openSignUpModal() {
      $('#loginModal').modal('hide')
      this.$nextTick(() => {
        this.$root.$emit('open-signup')
      })
    },

    handleForgotPassword() {
      // 处理忘记密码
      console.log('忘记密码')
    },

    showToast(type, message) {
      if (type === 'success') {
        this.$toast.success(message);
      } else if (type === 'error') {
        this.$toast.error(message);
      }
    },

    async handleSubmit() {
      if (!this.isFormValid) {
        this.showToast('error', '请填写完整表单');
        return;
      }

      try {
        const response = await fetch('/api/auth/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.formData)
        });
        
        if (response.ok) {
          const responseJson = await response.json();
          // console.log('登录响应：', responseJson);
          if (responseJson.code == 200) {
            // 保存用户信息到本地存储
            localStorage.setItem('userInfo', JSON.stringify(responseJson.data.user));
            localStorage.setItem('token', responseJson.data.token);
            // 更新父组件的用户状态
            this.$parent.currentUser = responseJson.data.user;
            this.showToast('success', '登录成功');
            $('#loginModal').modal('hide');
          } else {
            this.showToast('error', responseJson.message || '登录失败');
          }
        } else {
          const data = await response.json();
          this.showToast('error', responseJson.message || '登录失败');
        }
      } catch (error) {
        console.error('登录时出错：', error);
        this.showToast('error', '网络错误，请稍后再试');
      }
    }
  }
}
</script>

<style scoped>
.modal-dialog {
  max-width: 900px;
}

.modal-content {
  border-radius: 8px;
  border: none;
  overflow: hidden;
  position: relative;
}

.close {
  right: 1rem;
  top: 1rem;
  z-index: 1050;
}

.brand-section {
  background-color: #f8f9fa;
  padding: 3rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-height: 600px;
}

.brand-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 0;
}

.brand-logo {
  max-width: 120px;
  height: auto;
  margin-bottom: 2rem;
}

.welcome-text-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 4rem 0;
}

.welcome-text-container h2 {
  font-size: 2.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #333;
}

.welcome-text {
  font-size: 1.2rem;
  color: #666;
  line-height: 1.6;
  max-width: 80%;
  margin: 0 auto;
}

.login-hint {
  margin-top: auto;
  color: #666;
}

.login-hint a {
  color: #333;
  font-weight: 600;
  text-decoration: none;
}

.login-hint a:hover {
  text-decoration: underline;
}

.form-section {
  background-color: #fff;
}

.form-content {
  padding: 2rem 3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 600px;
}

.form-group {
  margin-bottom: 1.5rem;
}

.welcome-text-container {
  margin: 3rem 0;
}

.login-hint {
  margin-top: 2rem;
}

.btn-dark {
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}

.form-group label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #666;
  margin-bottom: 0.5rem;
}

.form-control {
  border-radius: 4px;
  padding: 0.75rem 1rem;
  border: 1px solid #ddd;
}

.forgot-password {
  color: #666;
  text-decoration: none;
  font-size: 0.9rem;
}

.forgot-password:hover {
  text-decoration: underline;
  color: #333;
}

.btn-success {
  background-color: #07C160;
  border-color: #07C160;
}

.btn-success:hover {
  background-color: #06AD56;
  border-color: #06AD56;
}

@media (max-width: 768px) {
  .modal-dialog {
    margin: 0.5rem;
  }
  
  .brand-section {
    display: none;
  }
  
  .form-content {
    padding: 1rem !important;
  }
}
</style>